import * as React from "react";

const SvgIcnInspectionsBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M14 4a1 1 0 011 1l.001 2.1a5 5 0 100 9.8L15 19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h9zm0 4a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 8zm0 1a3 3 0 100 6 3 3 0 000-6z"
        />
    </svg>
);

export default SvgIcnInspectionsBold;
